import { CALL_API } from "admin/middlewares/api";

export const CREDIT_SETTLEMENT_LIST_GET_REQUEST =
  "CREDIT_SETTLEMENT_LIST_GET_REQUEST";
export const CREDIT_SETTLEMENT_LIST_GET_SUCCESS =
  "CREDIT_SETTLEMENT_LIST_GET_SUCCESS";
export const CREDIT_SETTLEMENT_LIST_GET_ERROR =
  "CREDIT_SETTLEMENT_LIST_GET_ERROR";

export const CREDIT_SETTLEMENT_FOR_USER_GET_REQUEST =
  "CREDIT_SETTLEMENT_FOR_USER_GET_REQUEST";
export const CREDIT_SETTLEMENT_FOR_USER_GET_SUCCESS =
  "CREDIT_SETTLEMENT_FOR_USER_GET_SUCCESS";
export const CREDIT_SETTLEMENT_FOR_USER_GET_ERROR =
  "CREDIT_SETTLEMENT_FOR_USER_GET_ERROR";

export function get_settlements(
  accountId = null,
  paidOut = null,
  exported = null,
  fullyPaid = null,
  offset = null,
  take = null,
  types = null,
) {
  if (!types)
    types = accountId
      ? [
          CREDIT_SETTLEMENT_FOR_USER_GET_REQUEST,
          CREDIT_SETTLEMENT_FOR_USER_GET_SUCCESS,
          CREDIT_SETTLEMENT_FOR_USER_GET_ERROR,
        ]
      : [
          CREDIT_SETTLEMENT_LIST_GET_REQUEST,
          CREDIT_SETTLEMENT_LIST_GET_SUCCESS,
          CREDIT_SETTLEMENT_LIST_GET_ERROR,
        ];

  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/search",
      authenticatedRequest: true,
      data: {
        AccountId: accountId,
        PaidOut: paidOut,
        Exported: exported,
        FullyPaid: fullyPaid,
        Offset: offset,
        Take: take,
      },
      method: "POST",
      types: types,
    },
  };
}

export const CREDIT_SETTLEMENT_LIST_GET_DETAILS_REQUEST =
  "CREDIT_SETTLEMENT_LIST_GET_DETAILS_REQUEST";
export const CREDIT_SETTLEMENT_LIST_GET_DETAILS_SUCCESS =
  "CREDIT_SETTLEMENT_LIST_GET_DETAILS_SUCCESS";
export const CREDIT_SETTLEMENT_LIST_GET_DETAILS_ERROR =
  "CREDIT_SETTLEMENT_LIST_GET_DETAILS_ERROR";

export const CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_REQUEST =
  "CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_REQUEST";
export const CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_SUCCESS =
  "CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_SUCCESS";
export const CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_ERROR =
  "CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_ERROR";

export function get_loan_details(byid, accountId = null) {
  var actionTypes = accountId
    ? [
        CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_REQUEST,
        CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_SUCCESS,
        CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_ERROR,
      ]
    : [
        CREDIT_SETTLEMENT_LIST_GET_DETAILS_REQUEST,
        CREDIT_SETTLEMENT_LIST_GET_DETAILS_SUCCESS,
        CREDIT_SETTLEMENT_LIST_GET_DETAILS_ERROR,
      ];

  return {
    [CALL_API]: {
      endpoint: `/api/admin/loan/byId?id=${byid}`,
      additionalData: byid,
      authenticatedRequest: true,
      types: actionTypes,
    },
  };
}

export const LOAN_UPDATE_REQUEST = "LOAN_UPDATE_REQUEST";
export const LOAN_UPDATE_SUCCESS = "LOAN_UPDATE_SUCCESS";
export const LOAN_UPDATE_ERROR = "LOAN_UPDATE_ERROR";

export function update_loans() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/invoices/update-credit-states",
      authenticatedRequest: true,
      types: [LOAN_UPDATE_REQUEST, LOAN_UPDATE_SUCCESS, LOAN_UPDATE_ERROR],
    },
  };
}

export const CREDIT_SETTLEMENT_SET_DCA_PROCESS_REQUEST =
  "CREDIT_SETTLEMENT_SET_DCA_PROCESS_REQUEST";
export const CREDIT_SETTLEMENT_SET_DCA_PROCESS_SUCCESS =
  "CREDIT_SETTLEMENT_SET_DCA_PROCESS_SUCCESS";
export const CREDIT_SETTLEMENT_SET_DCA_PROCESS_ERROR =
  "CREDIT_SETTLEMENT_SET_DCA_PROCESS_ERROR";

export function add_to_dca_process(creditId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/credits/set-dca-process",
      authenticatedRequest: true,
      data: { CreditId: creditId },
      method: "POST",
      types: [
        CREDIT_SETTLEMENT_SET_DCA_PROCESS_REQUEST,
        CREDIT_SETTLEMENT_SET_DCA_PROCESS_SUCCESS,
        CREDIT_SETTLEMENT_SET_DCA_PROCESS_ERROR,
      ],
    },
  };
}

export const CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_REQUEST =
  "CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_REQUEST";
export const CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_SUCCESS =
  "CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_SUCCESS";
export const CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_ERROR =
  "CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_ERROR";

export function close_dca_process(creditId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/credits/close-in-dca",
      authenticatedRequest: true,
      data: { CreditId: creditId },
      method: "POST",
      types: [
        CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_REQUEST,
        CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_SUCCESS,
        CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_ERROR,
      ],
    },
  };
}

export const CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_REQUEST =
  "CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_REQUEST";
export const CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_SUCCESS =
  "CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_SUCCESS";
export const CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_ERROR =
  "CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_ERROR";

export function add_dca_monthly_repayment(
  principalAmount,
  interestAmount,
  feesAmount,
  OCR,
  bankReceiveDate,
  lastPayment,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/invoicebg/book-dca-monthly-repayment",
      authenticatedRequest: true,
      data: {
        PrincipalAmount: principalAmount,
        InterestAmount: interestAmount,
        FeesAmount: feesAmount,
        OCR: OCR,
        BankReceiveDate: bankReceiveDate,
        LastPayment: lastPayment,
      },
      method: "POST",
      types: [
        CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_REQUEST,
        CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_SUCCESS,
        CREDIT_SETTLEMENT_DCA_MONTHLY_REPAY_ERROR,
      ],
    },
  };
}
